var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    fill: "url(#pattern52)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern52",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_70_904",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_70_904",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAOYSURBVHhe7ZjJT1NRFIf5MxgKYSp7USNEwTGGhYkbN27YuDMmmmiCIXHlAleGiAoSBTGCRmQeBASCgNECbYEqBQvGYeGw1GhYSI7vNK9NS2+hiS3vvOvvl3wb7vDI+fLuua9pCIIgCIIgCIIgCIIgCKJz3P7VPR5/4JJ3ebUKxMK1WVgKFJvlSm1Yhtcf+GM8mMAWGDXaESnmm6H+J0AURq2qzbKlLp7ltcuqhwMF/kCNWbbUJZ6Q2TcrND7jpSmPL2aM8RhMuheNOfM0t/ROOUc7rBIy+tpDNx/1UO3DziDN3cM0+3YlPO7y+ele11B4/PbjXpqYW4jaQ0usEMJvRqSMEO0jL8JzWgfHYsbrn/QF35rIvbTDCiF8TG0uNtP4dCA8RyWMmY5zvGmDFUK4Z6iK3dQ9FJ5zp71fOcflWw7P0RKresj9nuGYYo+8cofH+yddMeOtA2NRe2iJVUK4gXPP4GOKG3qkjBCDUzPUZDT2xo4B6hydJvf/cNOySgiIA4QIA0KEASHCsEJIQ0sb7So7Cgy4FpG1sURIXdMDKiouAQZci8jaQIjFQIgwIEQYECIMCBEGhAgDQoQBIcKAEGFAiDAgRBgQIgwIEQaECANChAEhwrC/kH1l6r/bFNsLcUxOU+71G9qIsb2QLO88pRNR5qfPlH+xSjnHTmgjJIRjzk2FpyuVc+2AdkKCbGxQTncfFR4/oVwjGT2FmGT8+k25txqoqPSgcq1EbC+Ejyc+plRCQmR8+Up51VeoaHepcg9J2F5ICG7o3NhVQkJkLfqooPKMcr0UtBESpKQ8eETxUaUSwvARp1wrBL2EmHAz56bOzR1CEkiqhTDcWzI/fISQRJJKIVu9HRASJykRYlxtt+sf6T9+Ut7VGvV6IdhfiHGV5SstX22VEhj+UOzqJeeRCvUegrC9kOxnw2oJJo75RVv9lGJ7IfG+1DO+fU/sY9A46rI7upJKbm2d+lkJoJ+Q9XXKudtMzgOHlfM34yw/Fr0+CfzLxUErIY7xCSo8eUo5Lx4QYiTZQjLX3lPB2fPK8e2AECPJFJJ/7gI59+5XjiUEekhyhegGhAgDQoQBIcKAEGFAiDAgRBgQIgwIEQaECANChAEhwoAQYUCIMCBEGBAiDAgRBoQIQ4SQ5y9dVN/SBgy4FpG1sUQI2AIIEQaECGMnhBgPOeTxB66B7XEvByrMsiEIgiAIgiAIgiAIgiCIZklL+wuq7QNOQ1F42QAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShell);
export default __webpack_public_path__ + "static/media/shell.aa841bf59bcba62ecdb65518b8d18d3f.svg";
export { ForwardRef as ReactComponent };